

      <!--<div *ngFor="let l of CurrentActorEmpHistoryInfoController" >
        <div class="comon-box eh-box pb-0 border-bottom" *ngIf="ShowList">
          <div class="row pl-3 pr-3 margin-left-zero">
            <div class="col-md-12 add-new-cerit">
              
              <div class="edit-tools">
               
                <a (click)="edit_(l)" class="nav-link-hand education-navlink" *ngIf="CanEdit === 1 "><i class="fas fa-pencil-alt"></i></a>
                <a (click)="del_(l.EmpHistoryCode)" class="nav-link-hand education-navlink" *ngIf="CanEdit === 1 "><i class="far fa-trash-alt"></i></a>
                <a (click)="openDocContent(l.ActorDocCode)" class="nav-link-hand education-navlink">
                 
                   <i class="fas fa-paperclip"></i>
                  
                </a>
              </div>
              <div class="col-md-10 add-new-cerit">
                <div class="row ">

                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Employer</label>
                      <span class="form-result">{{l.EmployerName}}</span>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Address</label>
                      <span class="form-result">{{l.Address}}</span>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Title</label>
                      <span class="form-result">{{l.Responsibilities}}</span>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Duties & Responsibilities</label>
                      <span class="form-result">{{l.Duties}}</span>
                    </div>
                  </div>

                 

                  <div class="col-md-4">
                    <div class="form-group">
                      <label>From Date</label>
                      <span class="form-result">{{l.FromDate | date:'MMM-dd-yyyy'}} </span>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>To Date </label>
                      <span class="form-result">{{l.ToDate | date:'MMM-dd-yyyy'}}</span>
                    </div>
                  </div>
                 
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Reason For Leaving</label>
                      <span class="form-result">{{l.ReasonForLeaving}}</span>
                    </div>
                  </div>
                 
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>-->
<div class="card-content profile-eduction " *ngIf="ShowList">
  <div class="panel-heading">
    <div class="row">
      <div class="col-12">
        <!--<h6 class="panel-title fb">Education Info</h6>-->
        <div class="table-component">
          <div class="table-responsive">
            <table class="table  profile-table">
              <thead class="profile-thead ">
                <tr>
                  <th scope="col">Employer</th>
                  <th scope="col"> From Date</th>
                  <th scope="col">To Date</th>
                  <th scope="col">Still Working</th>
                  <th scope="col">May We Contact</th>
                  <th scope="col">Action</th>

                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let l of  CurrentActorEmpHistoryInfoController">
                  <td>{{l.EmployerName}}</td>
                  <td>{{l.FromDate | date:'MMM-dd-yyyy'}}</td>
                  <td>{{l.ToDate | date:'MMM-dd-yyyy'}}</td>
                  <td>{{l.IsCurrent}}</td>
                  <td>{{l.MayContact}}</td>
                 

                  <td>
                    <div class="row">
                      <a (click)="edit_(l)" class="nav-link-hand education-navlink" *ngIf="CanEdit === 1 ">
                        <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                      </a>
                      <a (click)="del_(l.EmpHistoryCode)" class="nav-link-hand education-navlink" *ngIf="CanEdit === 1 ">
                        <span class="badge">
                          <i class="far fa-trash-alt"></i>
                        </span>
                      </a>
                      <a (click)="openDocContent(l.ActorDocCode)" class="nav-link-hand education-navlink">
                        <span class="badge">
                          <!--<i class="fa fa-file grey"></i>--><i class="fas fa-paperclip"></i>
                        </span>
                      </a>
                    </div>
                  </td>
                </tr>

              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
      
        <div *ngIf='IsExpand'>
          <div class="row" *ngIf="ShowList">
            <div class="col-md-12 col-xs-12 mt-2 mb-4 text-right add-but">
              <button type="button" (click)="clearData()" class="btn btn-primary btn-sm"><!--<i class="fas fa-plus nav-link-hand"></i>--> Add New</button>
            </div>
          </div>
          <div *ngIf='isNew && !ShowList'>
            <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">

              <div class="comon-box margin-left-zero p-0">
                <h4 class="heading-pinkbg mt-0">Add Employment History</h4>
                <div class="row pl-3 pr-3 margin-left-zero ">


                  <div class="form-group col-md-6 col-xs-12">

                    <label for="eventInput2"><span>*</span> Employer </label>
                    <input type="text" class="form-control" id="CurrentActorEmpHistoryInfoRequest.EmployerName"
                           [(ngModel)]="CurrentActorEmpHistoryInfoRequest.EmployerName" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                           name="CurrentActorEmpHistoryInfoRequest.EmployerName" placeholder="Employer Name" required
                           maxlength="100" minlength="1" #EmployerName="ngModel">
                    <small class="form-text text-danger"
                           *ngIf="(!EmployerName.valid && (EmployerName.dirty || EmployerName.touched) && EmployerName.errors.required)">(Field cannot be left blank)</small>
                    <small class="form-text text-danger"
                           *ngIf="(!EmployerName.valid && EmployerName.errors.pattern)">(special characters are not allowed)</small>
                  </div>
                  <div class="form-group col-md-6 col-xs-12">
                    <label for="eventInput5">Address</label>
                    <input type="text" class="form-control"
                           id="CurrentActorEmpHistoryInfoRequest.Address"
                           [(ngModel)]="CurrentActorEmpHistoryInfoRequest.Address" pattern="^[\sa-zA-Z0-9,._\-?]*$" #Address="ngModel"
                           name="CurrentActorEmpHistoryInfoRequest.Address" placeholder="Address" maxlength="100">
                    <small class="form-text text-danger"
                           *ngIf="(!Address.valid && Address.errors.pattern)">(special characters are not allowed)</small>
                  </div>

                  <div class="form-group col-md-6 col-xs-12">
                    <label for="eventInput5">Title</label>
                    <input type="text" class="form-control" id="CurrentActorEmpHistoryInfoRequest.Responsibilities"
                           [(ngModel)]="CurrentActorEmpHistoryInfoRequest.Responsibilities" pattern="^[\sa-zA-Z0-9,._\-?]*$" #Responsibilities="ngModel"
                           name="CurrentActorEmpHistoryInfoRequest.Responsibilities" placeholder="Title" maxlength="100">
                    <small class="form-text text-danger"
                           *ngIf="(!Responsibilities.valid && Responsibilities.errors.pattern)">(special characters are not allowed)</small>

                  </div>

                  <div class="form-group col-md-6 col-xs-12">
                    <label for="eventInput4"><span>*</span> Duties & Responsibilities </label>
                    <input type="text" class="form-control" id="CurrentActorEmpHistoryInfoRequest.Duties"
                           [(ngModel)]="CurrentActorEmpHistoryInfoRequest.Duties" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                           name="CurrentActorEmpHistoryInfoRequest.Duties" placeholder="Duties  & Responsibilities" required
                           maxlength="100" minlength="1" #Duties="ngModel">
                    <small class="form-text text-danger"
                           *ngIf="(!Duties.valid && (Duties.dirty || Duties.touched)  && Duties.errors.required)">(Field cannot be left blank)</small>
                    <small class="form-text text-danger"
                           *ngIf="(!Duties.valid && Duties.errors.pattern)">(special characters are not allowed)</small>
                  </div>



                  <div class="form-group col-md-6 col-xs-12">
                    <label for="eventInput5">Still Working </label>
                    <!--<input type="checkbox" class="form-control" id="CurrentActorEmpHistoryInfoRequest.IsCurrent"
           [(ngModel)]="CurrentActorEmpHistoryInfoRequest.IsCurrent" name="CurrentActorEmpHistoryInfoRequest.IsCurrent" placeholder="IsCurrent">-->

                    <div class="radio-box">
                      <label class="radio-inline">

                        Yes  <input type="radio" [value]="true" class=""
                                    id="CurrentActorEmpHistoryInfoRequest.IsCurrent"
                                    [(ngModel)]="CurrentActorEmpHistoryInfoRequest.IsCurrent"
                                    name="CurrentActorEmpHistoryInfoRequest.IsCurrent">
                      </label>
                      <label class="radio-inline">
                        No <input type="radio" [value]="false" class=""
                                  id="CurrentActorEmpHistoryInfoRequest.IsCurrent"
                                  [(ngModel)]="CurrentActorEmpHistoryInfoRequest.IsCurrent"
                                  name="CurrentActorEmpHistoryInfoRequest.IsCurrent">
                      </label>
                      <!--<label class="radio-inline">
        Yes <input type="radio" id="CurrentActorEmpHistoryInfoRequest.IsCurrent" name="CurrentActorEmpHistoryInfoRequest.IsCurrent" [(ngModel)]="CurrentActorEmpHistoryInfoRequest.IsCurrent" value="true">
      </label>
      <label class="radio-inline">
        No <input type="radio" id="CurrentActorEmpHistoryInfoRequest.IsCurrent" name="CurrentActorEmpHistoryInfoRequest.IsCurrent" [(ngModel)]="CurrentActorEmpHistoryInfoRequest.IsCurrent" value="false">
      </label>-->

                    </div>

                  </div>

                  <div class="form-group col-md-6 col-xs-12">
                    <label for="eventInput5">From Date</label>
                    <!--<input type="date" class="form-control" id="CurrentActorEmpHistoryInfoRequest.FromDate"
    [(ngModel)]="CurrentActorEmpHistoryInfoRequest.FromDate"
    name="CurrentActorEmpHistoryInfoRequest.FromDate" placeholder="FromDate">-->
                    <!--<div *ngIf="CanAdjustgetTimezoneOffset">
      <input [owlDateTimeTrigger]="FromDate" class="form-control" [owlDateTime]="FromDate"
             [max]="MaxDateV"
             id="CurrentActorEmpHistoryInfoRequest.FromDate"
             placeholder="From Date"
             [(ngModel)]="CurrentActorEmpHistoryInfoRequest.FromDate"
             name="CurrentActorEmpHistoryInfoRequest.FromDate">
      <owl-date-time [pickerType]="'calendar'" #FromDate></owl-date-time>
    </div>-->
                    <div class="date-form">
                      <input class="form-control" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                             name="dp" [(ngModel)]="ValidFrom" ngbDatepicker #d="ngbDatepicker">

                      <a (click)="d.toggle()" class="nav-link-hand">
                        <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                      </a>

                    </div>
                  </div>

                  <div class="form-group col-md-6 col-xs-12">
                    <label for="eventInput5">To Date</label>
                    <!--<input type="date" class="form-control" id="CurrentActorEmpHistoryInfoRequest.ToDate"
    [(ngModel)]="CurrentActorEmpHistoryInfoRequest.ToDate"
    name="CurrentActorEmpHistoryInfoRequest.ToDate" placeholder="ToDate">-->
                    <!--<div *ngIf="CanAdjustgetTimezoneOffset">
      <input [owlDateTimeTrigger]="ToDate" class="form-control" [owlDateTime]="ToDate"
             [max]="MaxDateV"
             id="CurrentActorEmpHistoryInfoRequest.ToDate"
             placeholder="To Date"
             [(ngModel)]="CurrentActorEmpHistoryInfoRequest.ToDate"
             name="CurrentActorEmpHistoryInfoRequest.ToDate">
      <owl-date-time [pickerType]="'calendar'" #ToDate></owl-date-time>
    </div>-->
                    <div class="date-form">
                      <input class="form-control" placeholder="To Date" [minDate]="minDate" [maxDate]="maxDate"
                             name="dp1" [(ngModel)]="ValidTo" ngbDatepicker #d1="ngbDatepicker">

                      <button (click)="d1.toggle()" class="nav-link-hand" type="button">
                        <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                      </button>

                    </div>
                  </div>
                  <div class="form-group col-md-6 col-xs-12">
                    <label for="eventInput5">Supervisor Title</label>
                    <input type="text" class="form-control"
                           id="CurrentActorEmpHistoryInfoRequest.SupervisorTitle"
                           [(ngModel)]="CurrentActorEmpHistoryInfoRequest.SupervisorTitle" #SupervisorTitle="ngModel" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                           name="CurrentActorEmpHistoryInfoRequest.SupervisorTitle" placeholder="Supervisor Title" maxlength="100">
                    <small class="form-text text-danger"
                           *ngIf="(!SupervisorTitle.valid && SupervisorTitle.errors.pattern)">(special characters are not allowed)</small>
                  </div>
                  <div class="form-group col-md-6 col-xs-12">
                    <label for="eventInput5">Supervisor Name</label>
                    <input type="text" class="form-control"
                           id="CurrentActorEmpHistoryInfoRequest.SupervisorName"
                           [(ngModel)]="CurrentActorEmpHistoryInfoRequest.SupervisorName" #SupervisorName="ngModel" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                           name="CurrentActorEmpHistoryInfoRequest.SupervisorName" placeholder="Supervisor Name" maxlength="100">
                    <small class="form-text text-danger"
                           *ngIf="(!SupervisorName.valid && SupervisorName.errors.pattern)">(special characters are not allowed)</small>
                  </div>
                  <div class="form-group col-md-6 col-xs-12 radio-box ">
                    <label for="eventInput5">May We Contact</label>
                    <!--<input type="checkbox" class="form-control"
           id="CurrentActorEmpHistoryInfoRequest.MayContact"
           [(ngModel)]="CurrentActorEmpHistoryInfoRequest.MayContact"
           name="CurrentActorEmpHistoryInfoRequest.MayContact" placeholder="MayContact">-->
                    <label class="radio-inline">
                      Yes  <input type="radio" [value]="true" class=""
                                  id="CurrentActorEmpHistoryInfoRequest.MayContact"
                                  [(ngModel)]="CurrentActorEmpHistoryInfoRequest.MayContact"
                                  name="CurrentActorEmpHistoryInfoRequest.MayContact">
                    </label>
                    <label class="radio-inline">
                      No <input type="radio" [value]="false" class=""
                                id="CurrentActorEmpHistoryInfoRequest.MayContact"
                                [(ngModel)]="CurrentActorEmpHistoryInfoRequest.MayContact"
                                name="CurrentActorEmpHistoryInfoRequest.MayContact">
                    </label>
                  </div>
                  <div class="form-group col-md-6 col-xs-12">
                    <label for="eventInput5">Phone Number</label>
                    <input type="text" class="form-control"
                           id="CurrentActorEmpHistoryInfoRequest.PhoneNo"
                           [(ngModel)]="CurrentActorEmpHistoryInfoRequest.PhoneNo"
                           mask="(000) 000-0000"
                           pattern="[0-9]{10}" #PhoneNo="ngModel"
                           name="CurrentActorEmpHistoryInfoRequest.PhoneNo" placeholder="Phone Number">
                    <small class="form-text text-danger"
                           *ngIf="(!PhoneNo.valid && PhoneNo.errors.pattern)">(Provide Valid Phone No)</small>
                  </div>

                  <div class="form-group col-md-6 col-xs-12">
                    <label for="eventInput5">Reason For Leaving</label>
                    <input type="text" class="form-control"
                           id="CurrentActorEmpHistoryInfoRequest.ReasonForLeaving"
                           [(ngModel)]="CurrentActorEmpHistoryInfoRequest.ReasonForLeaving" #ReasonForLeaving="ngModel" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                           name="CurrentActorEmpHistoryInfoRequest.ReasonForLeaving" placeholder="Reason For Leaving" maxlength="100">
                    <small class="form-text text-danger"
                           *ngIf="(!ReasonForLeaving.valid && ReasonForLeaving.errors.pattern)">(special characters are not allowed)</small>
                  </div>
                  <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
                  <!--<div class="card-footer pink-bg text-right" *ngIf="CanEdit === 1 ">
    <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn actions-btn-prime">Save</button>

  </div>-->
                </div>


              </div>
              <div class="row" *ngIf="CanEdit === 1 ">
                <div class="card-footer text-right col-12">
                  <button type="button" (click)="CancelNewOperation()" *ngIf='!isRequesting' class="btn actions-btn-prime nav-link-hand button-Schedule actions-btn-prime3">Cancel</button>
                  <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn actions-btn-prime nav-link-hand">Save</button>


                </div>
              </div>






            </form>
          </div>
          <div *ngIf='isEdit && !ShowList'>
            <form class="form" novalidate="" (ngSubmit)="onEditSubmit()" #f="ngForm">

              <div class="comon-box p-0 margin-left-zero">
                <h4 class="heading-pinkbg mt-0">Update Employment History</h4>
                <div class="row pl-3 pr-3 margin-left-zero">






                  <div class="form-group col-md-6 col-xs-12">

                    <label for="eventInput2"><span>*</span> Employer </label>
                    <input type="text" class="form-control" id="CurrentActorEditEmpHistoryInfoRequest.EmployerName"
                           [(ngModel)]="CurrentActorEditEmpHistoryInfoRequest.EmployerName" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                           name="CurrentActorEditEmpHistoryInfoRequest.EmployerName" placeholder="Employer Name" required
                           maxlength="100" minlength="1" #EmployerName="ngModel">
                    <small class="form-text text-danger"
                           *ngIf="(!EmployerName.valid && (EmployerName.dirty || EmployerName.touched)  && EmployerName.errors.required)">(Field cannot be left blank)</small>
                    <small class="form-text text-danger"
                           *ngIf="(!EmployerName.valid && EmployerName.errors.pattern)">(special characters are not allowed)</small>
                  </div>
                  <div class="form-group col-md-6 col-xs-12">
                    <label for="eventInput5">Address</label>
                    <input type="text" class="form-control"
                           id="CurrentActorEditEmpHistoryInfoRequest.Address"
                           [(ngModel)]="CurrentActorEditEmpHistoryInfoRequest.Address" pattern="^[\sa-zA-Z0-9,._\-?]*$" #Address="ngModel"
                           name="CurrentActorEditEmpHistoryInfoRequest.Address" placeholder="Address" maxlength="100">
                    <small class="form-text text-danger"
                           *ngIf="(!Address.valid && Address.errors.pattern)">(special characters are not allowed)</small>
                  </div>
                  <div class="form-group col-md-6 col-xs-12">
                    <label for="eventInput5">Title</label>
                    <input type="text" class="form-control" id="CurrentActorEditEmpHistoryInfoRequest.Responsibilities" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                           [(ngModel)]="CurrentActorEditEmpHistoryInfoRequest.Responsibilities" #Responsibilities="ngModel"
                           name="CurrentActorEditEmpHistoryInfoRequest.Responsibilities" placeholder="Title" maxlength="100">
                    <small class="form-text text-danger"
                           *ngIf="(!Responsibilities.valid && Responsibilities.errors.pattern)">(special characters are not allowed)</small>

                  </div>

                  <div class="form-group col-md-6 col-xs-12">
                    <label for="eventInput4"><span>*</span> Duties & Responsibilities </label>
                    <input type="text" class="form-control" id="CurrentActorEditEmpHistoryInfoRequest.Duties"
                           [(ngModel)]="CurrentActorEditEmpHistoryInfoRequest.Duties" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                           name="CurrentActorEditEmpHistoryInfoRequest.Duties" placeholder="Duties  & Responsibilities" required
                           maxlength="100" minlength="1" #Duties="ngModel">
                    <small class="form-text text-danger"
                           *ngIf="(!Duties.valid && (Duties.dirty || Duties.touched)  && Duties.errors.required)">(Field cannot be left blank)</small>
                    <small class="form-text text-danger"
                           *ngIf="(!Duties.valid && Duties.errors.pattern)">(special characters are not allowed)</small>
                  </div>



                  <div class="form-group col-md-6 col-xs-12">
                    <label for="eventInput5">Still Working </label>
                    <!--<input type="checkbox" class="form-control" id="CurrentActorEditEmpHistoryInfoRequest.IsCurrent"
    [(ngModel)]="CurrentActorEditEmpHistoryInfoRequest.IsCurrent" name="CurrentActorEditEmpHistoryInfoRequest.IsCurrent" placeholder="IsCurrent">-->

                    <label class="radio-inline">

                      Yes  <input type="radio" [value]="true" class=""
                                  id="CurrentActorEditEmpHistoryInfoRequest.IsCurrent"
                                  [(ngModel)]="CurrentActorEditEmpHistoryInfoRequest.IsCurrent"
                                  name="CurrentActorEditEmpHistoryInfoRequest.IsCurrent">
                    </label>
                    <label class="radio-inline">
                      No <input type="radio" [value]="false" class=""
                                id="CurrentActorEditEmpHistoryInfoRequest.IsCurrent"
                                [(ngModel)]="CurrentActorEditEmpHistoryInfoRequest.IsCurrent"
                                name="CurrentActorEditEmpHistoryInfoRequest.IsCurrent">
                    </label>

                    <!--<div class="radio-box">
      <label class="radio-inline">
        <input type="radio" id="CurrentActorEditEmpHistoryInfoRequest.IsCurrent" name="CurrentActorEditEmpHistoryInfoRequest.IsCurrent" [(ngModel)]="CurrentActorEditEmpHistoryInfoRequest.IsCurrent" value="true"> Yes
      </label>
      <label class="radio-inline">
        <input type="radio" id="CurrentActorEditEmpHistoryInfoRequest.IsCurrent" name="CurrentActorEditEmpHistoryInfoRequest.IsCurrent" [(ngModel)]="CurrentActorEditEmpHistoryInfoRequest.IsCurrent" value="false"> No
      </label>

    </div>-->
                  </div>


                  <!--<div class="form-group col-md-6 col-xs-12">
  <label for="eventInput5">Still Working </label>
  IsCurrent: {{CurrentActorEditEmpHistoryInfoRequest.IsCurrent }}-->
                  <!--<div *ngIf="CurrentActorEditEmpHistoryInfoRequest.IsCurrent === true; then YesChecked else NoChecked"></div>

  <ng-template #YesChecked>

    <label class="radio-inline">

      <input type="radio" id="CurrentActorEditEmpHistoryInfoRequest.IsCurrent" name="CurrentActorEditEmpHistoryInfoRequest.IsCurrent" [(ngModel)]="CurrentActorEditEmpHistoryInfoRequest.IsCurrent"
             value="true" checked="checked"> Yes

    </label>
    <label class="radio-inline">
      <input type="radio" id="CurrentActorEditEmpHistoryInfoRequest.IsCurrent"
             name="CurrentActorEditEmpHistoryInfoRequest.IsCurrent" [(ngModel)]="CurrentActorEditEmpHistoryInfoRequest.IsCurrent" value="false" > No


    </label>
  </ng-template>
  <ng-template #NoChecked>

    <label class="radio-inline">

      <input type="radio" id="CurrentActorEditEmpHistoryInfoRequest.IsCurrent"
             name="CurrentActorEditEmpHistoryInfoRequest.IsCurrent" [(ngModel)]="CurrentActorEditEmpHistoryInfoRequest.IsCurrent"
             value="true"> Yes

    </label>
    <label class="radio-inline">
      <input type="radio" id="CurrentActorEditEmpHistoryInfoRequest.IsCurrent" name="CurrentActorEditEmpHistoryInfoRequest.IsCurrent"
             [(ngModel)]="CurrentActorEditEmpHistoryInfoRequest.IsCurrent" value="false" checked="checked"> No
    </label>
  </ng-template>-->
                  <!--<label class="radio-inline">

    <input type="radio" id="CurrentActorEditEmpHistoryInfoRequest.IsCurrent" name="CurrentActorEditEmpHistoryInfoRequest.IsCurrent" [(ngModel)]="CurrentActorEditEmpHistoryInfoRequest.IsCurrent"
           value="true" checked="checked"> Yes

  </label>
  <label class="radio-inline">
    <input type="radio" id="CurrentActorEditEmpHistoryInfoRequest.IsCurrent"
           name="CurrentActorEditEmpHistoryInfoRequest.IsCurrent" [(ngModel)]="CurrentActorEditEmpHistoryInfoRequest.IsCurrent" value="false" checked="checked" > No


  </label>-->
                  <!--</div>-->


                  <div class="form-group col-md-6 col-xs-12">
                    <label for="eventInput5">From Date</label>

                    <!--<input #myDatePicker type="date" class="form-control"
    value='{{ CurrentActorEditEmpHistoryInfoRequest.FromDate | date:"yyyy-MM-dd" }}'
    (input)="onInputValidFrom(myDatePicker.value)"
    placeholder="From Date" />-->
                    <!--<div *ngIf="CanAdjustgetTimezoneOffset">
      <input [owlDateTimeTrigger]="FromDate" class="form-control" [owlDateTime]="FromDate"
             [max]="MaxDateV"
             id="CurrentActorEditEmpHistoryInfoRequest.FromDate"
             placeholder="From Date"
             [(ngModel)]="CurrentActorEditEmpHistoryInfoRequest.FromDate"
             name="CurrentActorEditEmpHistoryInfoRequest.FromDate">
      <owl-date-time [pickerType]="'calendar'" #FromDate></owl-date-time>
    </div>-->
                    <div class="date-form">
                      <input class="form-control" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                             name="dp" [(ngModel)]="ValidFrom" ngbDatepicker #d="ngbDatepicker">



                      <a (click)="d.toggle()" class="nav-link-hand">
                        <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                      </a>

                    </div>
                  </div>

                  <div class="form-group col-md-6 col-xs-12">
                    <label for="eventInput5">To Date</label>

                    <!--<input #myDatePicker1 type="date" class="form-control"
    value='{{ CurrentActorEditEmpHistoryInfoRequest.ToDate | date:"yyyy-MM-dd" }}'
    (input)="onInputValidTo(myDatePicker1.value)"
    placeholder="To Date" />-->
                    <!--<div *ngIf="CanAdjustgetTimezoneOffset">
      <input [owlDateTimeTrigger]="ToDate" class="form-control" [owlDateTime]="ToDate"
             [max]="MaxDateV"
             id="CurrentActorEditEmpHistoryInfoRequest.ToDate"
             placeholder="To Date"
             [(ngModel)]="CurrentActorEditEmpHistoryInfoRequest.ToDate"
             name="CurrentActorEditEmpHistoryInfoRequest.ToDate">
      <owl-date-time [pickerType]="'calendar'" #ToDate></owl-date-time>
    </div>-->
                    <div class="date-form">
                      <input class="form-control" placeholder="To Date" [minDate]="minDate" [maxDate]="maxDate"
                             name="dp1" [(ngModel)]="ValidTo" ngbDatepicker #d1="ngbDatepicker">

                      <a (click)="d1.toggle()" class="nav-link-hand">
                        <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                      </a>

                    </div>
                  </div>
                  <div class="form-group col-md-6 col-xs-12">
                    <label for="eventInput5">Supervisor Title</label>
                    <input type="text" class="form-control"
                           id="CurrentActorEditEmpHistoryInfoRequest.SupervisorTitle" #SupervisorTitle="ngModel" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                           [(ngModel)]="CurrentActorEditEmpHistoryInfoRequest.SupervisorTitle"
                           name="CurrentActorEditEmpHistoryInfoRequest.SupervisorTitle" placeholder="Supervisor Title" maxlength="100">
                    <small class="form-text text-danger"
                           *ngIf="(!SupervisorTitle.valid && SupervisorTitle.errors.pattern)">(special characters are not allowed)</small>
                  </div>
                  <div class="form-group col-md-6 col-xs-12">
                    <label for="eventInput5">Supervisor Name</label>
                    <input type="text" class="form-control"
                           id="CurrentActorEditEmpHistoryInfoRequest.SupervisorName"
                           [(ngModel)]="CurrentActorEditEmpHistoryInfoRequest.SupervisorName" #SupervisorName="ngModel" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                           name="CurrentActorEditEmpHistoryInfoRequest.SupervisorName" placeholder="Supervisor Name" maxlength="100">
                    <small class="form-text text-danger"
                           *ngIf="(!SupervisorName.valid && SupervisorName.errors.pattern)">(special characters are not allowed)</small>
                  </div>
                  <div class="form-group col-md-6 col-xs-12 radio-box">
                    <label for="eventInput5">May We Contact</label>
                    <!--<input type="checkbox" class="form-control"
           id="CurrentActorEditEmpHistoryInfoRequest.MayContact"
           [(ngModel)]="CurrentActorEditEmpHistoryInfoRequest.MayContact"
           name="CurrentActorEditEmpHistoryInfoRequest.MayContact" placeholder="MayContact">-->
                    <label class="radio-inline">

                      Yes  <input type="radio" [value]="true" class=""
                                  id="CurrentActorEditEmpHistoryInfoRequest.MayContact"
                                  [(ngModel)]="CurrentActorEditEmpHistoryInfoRequest.MayContact"
                                  name="CurrentActorEditEmpHistoryInfoRequest.MayContact">
                    </label>
                    <label class="radio-inline">
                      No <input type="radio" [value]="false" class=""
                                id="CurrentActorEditEmpHistoryInfoRequest.MayContact"
                                [(ngModel)]="CurrentActorEditEmpHistoryInfoRequest.MayContact"
                                name="CurrentActorEditEmpHistoryInfoRequest.MayContact">
                    </label>
                  </div>
                  <div class="form-group col-md-6 col-xs-12">
                    <label for="eventInput5">Phone Number</label>
                    <input type="text" class="form-control"
                           id="CurrentActorEditEmpHistoryInfoRequest.PhoneNo"
                           [(ngModel)]="CurrentActorEditEmpHistoryInfoRequest.PhoneNo" pattern="[0-9]{10}" #PhoneNo="ngModel"
                           name="CurrentActorEditEmpHistoryInfoRequest.PhoneNo" placeholder="Phone Number" maxlength="10">
                    <small class="form-text text-danger"
                           *ngIf="(!PhoneNo.valid && PhoneNo.errors.pattern)">(Provide Valid Phone No)</small>
                  </div>

                  <div class="form-group col-md-6 col-xs-12">
                    <label for="eventInput5">Reason For Leaving</label>
                    <input type="text" class="form-control"
                           id="CurrentActorEditEmpHistoryInfoRequest.ReasonForLeaving"
                           [(ngModel)]="CurrentActorEditEmpHistoryInfoRequest.ReasonForLeaving" #ReasonForLeaving="ngModel" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                           name="CurrentActorEditEmpHistoryInfoRequest.ReasonForLeaving" placeholder="ReasonForLeaving" maxlength="100">

                    <small class="form-text text-danger"
                           *ngIf="(!ReasonForLeaving.valid && ReasonForLeaving.errors.pattern)">(special characters are not allowed)</small>
                  </div>
                  <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
                  <!--<div class="card-footer pink-bg text-right" *ngIf="CanEdit === 1 ">
    <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn actions-btn-prime">Update</button>

  </div>-->
                </div>


              </div>

              <div class="row" *ngIf="CanEdit === 1 ">
                <div class="card-footer text-right col-12">
                  <button (click)="CancelUpdateOperation()" *ngIf='!isRequesting' class="btn button-Schedule actions-btn-prime nav-link-hand actions-btn-prime3">Cancel</button>
                  <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn actions-btn-prime nav-link-hand">Update</button>


                </div>
              </div>





            </form>
          </div>
        </div>


        <!--<div class="row">
    <div class="form-group col-md-12 col-xs-12 mt-5"><a href="#finish" role="menuitem" class="btn-blue-main">Save</a></div>
  </div>-->
